import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@src/store";

import { GroupSliderRoundedPercentages, IGroupSliderState } from "./types";

const initialState: IGroupSliderState = {};

// We load a lot of data in the views (more than we should), which causes
// performance issues for components that trigger render updates fast.
// To bypass those problems we track performance sensitive state of those
// components in a separate slice.
const groupSliderSlicer = createSlice({
  name: "groupSlider",
  initialState,
  reducers: {
    setGroupSliderPercentages: (
      state,
      action: PayloadAction<{
        id: string;
        percentages: GroupSliderRoundedPercentages | undefined;
      }>
    ) => {
      const { id, percentages } = action.payload;
      if (percentages !== undefined) {
        state[id] = percentages;
      } else {
        delete state[id];
      }
    },
  },
});

export const groupSliderReducer = groupSliderSlicer.reducer;
export const { setGroupSliderPercentages } = groupSliderSlicer.actions;

export const getGroupSliderPercentageFactory =
  (sliderId: string, groupId: string | number) => (state: RootState) =>
    state.groupSlider[sliderId]?.[groupId];
